module.exports = __webpack_public_path__ + "static/media/main idea.fb57b099.mp3";